import CarouselProducts from 'CarouselProducts';
import Head from 'next/head';
import { MdSearch } from 'react-icons/md';
import Brands from '../../domain/CarouselsHome/Brands';
import Layout from '../../domain/Layout';
import styles from '../../styles/pages/no-results.module.scss';

export default function NoResultsWrapper(props) {
   const { title, brands, promotedProducts } = props;
   return (
      <Layout
         description="Lo sentimos, la página que buscas no está disponible. Explora nuestro ecommerce para descubrir productos emocionantes y ofertas increíbles. ¡Te invitamos a explorar lo que tenemos para ti!"
         title={title}
      >
         <Head>
            <meta name="robots" content="noindex,nofollow" key="robotsKey" />
         </Head>
         <div className={styles.container}>
            <div className={styles.wrapperMessage}>
               <MdSearch />
               <span>No pudimos encontrar ningún resultado probá una búsqueda diferente</span>
            </div>
            {brands.lenght > 0 && (
               <div className={styles.carousel}>
                  <Brands brands={brands} />
               </div>
            )}
            {promotedProducts.lenght > 0 && (
               <div className={styles.carousel}>
                  <CarouselProducts title="Promociones" products={promotedProducts} />
               </div>
            )}
         </div>
      </Layout>
   );
}
